import React from 'react';
import styled from 'styled-components';
import {
  FINDING_HIT_TARGET_SIZE,
  getFindingKey,
} from '../../lib/threejs/findingMarkers';

const FindingsPanel = styled.div`
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 12;
  width: min(320px, calc(100% - 32px));
  padding: 14px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 4px 18px rgba(48, 57, 69, 0.2);
  color: #303945;
  pointer-events: none;

  .finding-title {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-weight: 600;
  }

  .finding-meta {
    margin-top: 4px;
    color: #717880;
    font-size: 13px;
  }

  .finding-comment {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.35;
  }
`;

const FindingsHitLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 11;
  overflow: hidden;
  pointer-events: none;

  button {
    position: absolute;
    top: 0;
    left: 0;
    width: ${FINDING_HIT_TARGET_SIZE}px;
    height: ${FINDING_HIT_TARGET_SIZE}px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    outline: 0;
    background: transparent;
    cursor: pointer;
    pointer-events: auto;
  }
`;

const stopMouseInteraction = (event) => {
  event.preventDefault();
  event.stopPropagation();
};

const FindingsOverlay = ({
  findings,
  selectedFinding,
  hitTargets,
  onSelect,
}) => {
  const meta = selectedFinding
    ? [
        selectedFinding.toothNumber > 0
          ? `Tooth ${selectedFinding.toothNumber}`
          : null,
        selectedFinding.plan,
      ]
        .filter(Boolean)
        .join(' \u00b7 ')
    : '';

  return (
    <>
      <FindingsHitLayer>
        {findings.map((finding) => {
          const key = getFindingKey(finding);
          return (
            <button
              key={key}
              ref={(element) => {
                if (element) hitTargets.current.set(key, element);
                else hitTargets.current.delete(key);
              }}
              type="button"
              tabIndex={-1}
              aria-label={`${finding.id}. ${finding.findingName}`}
              onMouseDown={stopMouseInteraction}
              onClick={(event) => {
                stopMouseInteraction(event);
                onSelect(finding);
              }}
            />
          );
        })}
      </FindingsHitLayer>

      {selectedFinding && (
        <FindingsPanel>
          <div className="finding-title">
            <span>
              {selectedFinding.id}. {selectedFinding.findingName}
            </span>
          </div>
          {meta && <div className="finding-meta">{meta}</div>}
          {selectedFinding.comment && (
            <div className="finding-comment">{selectedFinding.comment}</div>
          )}
        </FindingsPanel>
      )}
    </>
  );
};

export default React.memo(FindingsOverlay);
